<ul class="content__sidebar-menu">
  <!-- Botón Calendario -->
  @if (showCalendarOption) {
    <li class="content__treeview-menu menu-calendar mb-3 mt-3">
      <a class="d-block content__treeview-link" (click)="showCalendar()" style="cursor: pointer;">
        <span class="font-weight-bold">
          <i class="fas fa-calendar-alt mr-2"></i>Calendario
        </span>
      </a>
    </li>
  }

  <!-- Botón Notificaciones -->
  @if (domainConfigComponent.configMyActivities) {
    <li class="content__treeview-menu menu-activities mb-3 mt-3">
      <span class="d-block d-flex justify-content-between content__treeview-link" (click)="showActivities()">
        <span class="font-weight-bold">Notificaciones (Beta)</span>
        <span class="pull-right pr-2 d-flex align-items-center">
          <span class="content__sidebar-count badget-activities rounded">{{activitiesBadget}}</span>
          <i class="fas fa-chevron-down ml-2 green"></i>
        </span>
      </span>
    </li>
  }

  <!-- Botón Monitoreo PJUD (3.er ítem del menú superior) -->
  @if (showPjudIndicatorsOption) {
    <li class="content__treeview-menu menu-pjud-indicators mb-3 mt-3">
      <a class="d-block content__treeview-link" routerLink="/pjud-indicators">
        <span class="font-weight-bold">
          <i class="fas fa-balance-scale mr-2"></i>Monitoreo PJUD
        </span>
      </a>
    </li>
  }
</ul>
<ng-template [ngxPermissionsOnly]="['trackvision.visibility.filtertab']">
  <ul ngbNav class="nav nav-tabs" #nav="ngbNav" class="nav-tabs">
    <li ngbNavItem>
      <a ngbNavLink (click)="showMyRequirements(false)">Equipo</a>
    </li>
    <li ngbNavItem>
      <a ngbNavLink (click)="showMyRequirements(true)">Propios</a>
    </li>
  </ul>
</ng-template>
<div class="row mt-2">
  <div class="col">
    <h4 class="requirement__table-title">
      Flujos
    </h4>
  </div>
</div>
<ul class="content__sidebar-menu">
  @for (visibility of visibilities; track visibility; let i = $index) {
    <li
      class="content__treeview-menu mb-3 mt-3 is-closed"
    [ngClass]="{
      'is-opened': visibility.id === visibilityGroupIdActived,
      'is-closed': visibility.id !== visibilityGroupIdActived
    }"
      id="{{ 'sidebar-li-' + i }}"
      >
      <span
        (click)="showMenu(visibility.id)"
        class="d-block d-flex justify-content-between content__treeview-link" >
        <span class="font-weight-bold d-flex align-items-center">
          {{ visibility.name }}
          @if (showUnreadMessageBadge(visibility.unreadClientMessageCount)) {
            <span
              class="badge portal-unread-msg-badge ml-2"
              title="{{ unreadMessageBadgeLabel(visibility.unreadClientMessageCount) }} mensaje(s) del cliente sin leer en este grupo"
              ><i class="fas fa-comment" aria-hidden="true"></i>{{ unreadMessageBadgeLabel(visibility.unreadClientMessageCount) }}</span
            >
          }
        </span>
        <span class="pull-right pr-2 d-flex align-items-center">
          <span class="content__sidebar-count bg-secondary text-white rounded">{{
            getSectionBadge(visibility)
          }}</span>
          <i class="fas fa-chevron-down ml-2"></i>
        </span>
      </span>
      @for (item of visibility.items; track item) {
        <ul
          class="content__treeview-menu tree mt-2"
          >
          <li [ngClass]="{ 'is-active': item.id === visibilityIdActive }">
            <button type="button" (click)="sendVisibilityId(item.id)">
              <span
                class="content__sidebar-count bg-secondary text-white rounded mr-2"
                >{{ item.count }}</span
                >
              <span class="text-dark d-inline-flex align-items-center">
                {{ item.name }}
                @if (!isTodosVisibilityItem(item) && showUnreadMessageBadge(item.unreadClientMessageCount)) {
                  <span
                    class="badge portal-unread-msg-badge ml-2"
                    title="{{ unreadMessageBadgeLabel(item.unreadClientMessageCount) }} mensaje(s) del cliente sin leer en esta etapa"
                    ><i class="fas fa-comment" aria-hidden="true"></i>{{ unreadMessageBadgeLabel(item.unreadClientMessageCount) }}</span
                  >
                }
              </span>
            </button>
            </li>
          </ul>
        }
      </li>
    }
  </ul>
